import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, TextInput } from '../../types'

@Injectable({ providedIn: 'root' })
export class LiveChatConverter extends CmsConverterService<LiveChatData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      botHash: formData.st_hash ?? defaultTextInput,
      clientId: formData.st_id ?? defaultTextInput
    }
  }
}

export const LIVE_CHAT_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, LiveChatData>>('LiveChatConverter')

export interface LiveChatData extends ConvertedComponentData {
  botHash: TextInput;
  clientId: TextInput;
}
